export enum BidStatus {
	New = "New",
	Draft = "Draft",
	RequestToEstablishCommitees = "Request to establish Commitees",
	RequestToScheduleCommiteeMeetings = "Request to schedule Commitee Meetings",
	SubmittedForBidSpec = "Submitted for Bid Spec",
	SubmittedForBidSpecification = "Submitted For Bid Specification",
	DefineEvaluationCriteria = "Define evaluation criteria",
	RequestForApproval = "Request For Approval",
	RequestToPublish = "Request to Publish",
	SupplierBidding = "Supplier Bidding",
	Evaluation = "Evaluation",
	Recommend = "Recommend",
	Award = "Award",
	BidSpecification = "Bid Specification",
	SubmittedForApproval = "Submitted for Approval",
	Approved = "Approved",
	Open = "Open",
	Closed = "Closed",
	BidRecommendation = "Bid Recommendation",
	Cancelled = "Cancelled",
	Completed = "Completed",
	Rejected = "Rejected",
	BidEvaluation = "Bid Evaluation",
	PreScreening = "Pre-Screening",
	FunctionalityEvaluation = "Functionality Evaluation",
	PresentationEvaluation = "Presentation Evaluation",
	SiteEvaluation = "Site Evaluation",
	TechnicalEvaluation = "Technical Evaluation",
	PriceAndBeeEvaluation = "Price and Bee Evaluation",
	Adjudication = "Adjudication",
}

export enum BidAssigned {
	AssignedToMe = 1,
	CreatedByMe = 2,
}

export enum BidStepHistoryStatus {
	Completed = "Completed",
	Ready = "Ready",
	Pending = "Pending",
	Recalled = "Recalled",
	ChangeRequested = "Change Requested",
	Rejected = "Rejected",
	Deleted = "Deleted",
	Delegated = "Delegated",
	Escalated = "Escalated",
	Cancelled = "Cancelled",
}

export enum BidActionType {
	Edit = "edit",
}

export enum BidConversationType {
	Procurement = 1,
	RFI = 2,
}

export enum BidConfirmationType {
	Approve = "approve",
	TaskCompletion = "task-complete",
	ChangeRequest = "change-request",
	Delegation = "delegate",
	Rejection = "reject",
	Recall = "recall",
}
